<template>
    <el-card>
        <template slot='header'>
        <div>
            <span>财务开票信息</span>
        </div>
        </template>
        <ly-information 
            :config="infoConfig"
            :data="info"
            class="mt15"
            v-if="type == 'show'">        
        </ly-information>
        <Ly-search-form 
            :config="formConfig" 
            :rules="formRules"
            :is-search="false"
            label-width="120px"
            v-else
            ref="searchForm">
        </Ly-search-form>
    </el-card>
</template>
<script>
    import {mapGetters} from 'vuex'
    import LySearchForm from '@c/search-form'
    import LyInformation from '@c/information'
    /**
     * 财务开票操作
     * @time 2018-03-19
     * @author zjs
     */
    export default {
        props: {
            infoId: [String, Number], // 发票登记的ID
            info: {
                type: Object,
                default: function () {
                    return {}
                }
            }, // 显示的数据
            type: {
                type: String,
                default: 'show'
            } // 显示类型［show：显示，update: 操作］
        },
        components: {
            LySearchForm,
            LyInformation
        },
        data () {
            // 非空的判断
            var isNoEmpty = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入'))
                } else {
                    callback()
                }
            }
            return {
                formConfig: [{
                    name: "财务开票类型",
                    type: "LySelect",
                    field: "finance_invoice_type",
                    json: { 
                        all: false,
                        data: [{
                            value: '1',
                            label: '增发票'
                        }, {
                            value: '2',
                            label: '普票'
                        }]
                    },
                    default: "1"
                }, {                   
                    name: "开票日期",
                    type: "LyDatePicker",
                    field: "finance_work_time",
                    json: {
                        type: 'date'
                    },
                    default: ""
                }, {
                    name: "财务开票人",
                    type: "ElInput",
                    field: "caiwukpr",
                    json: {
                        disabled: true,
                    },
                    default: ""
                }, {
                    name: "发票号码",
                    type: "ElInput",
                    field: "finance_no",
                    default: ""
                }, {
                    name: "实际开票金额",
                    type: "LyInputNumber",
                    field: "finance_amount",
                    width:'220px',
                    default: ""
                }, {
                    name: "发票代收税金",
                    type: "LyInputNumber",
                    field: "finance_tax",
                    width:'220px',
                    default: ""
                }, {
                    name: "备注",
                    type: "ElInput",
                    field: "finance_zhaiyao",
                    default: ""
                }, {
                    name: "发票领取备注",
                    type: "ElInput",
                    field: "invoice_get_zhaiyao",
                    default: ""
                }], // 表单信息配置
                formRules: {
                    finance_no: [{ required: true, trigger: 'blur' }],
                    finance_amount: [{ validator: isNoEmpty, required: true, trigger: 'blur' }]
                },
                // 显示信息的配置
                infoConfig: [
                    {"label":"财务开票类型","prop":"finance_invoice_type"},
                    {"label":"开票日期","prop":"finance_work_time"},
                    {"label":"发票号码","prop":"finance_no"},
                    {"label":"实际开票金额","prop":"finance_amount"},
                    {"label":"财务开票人","prop":"caiwukpr"},
                    {"label":"发票代收税金","prop":"finance_tax"},
                    {"label":"备注","prop":"finance_zhaiyao"},
                    {"label":"发票领取备注","prop":"invoice_get_zhaiyao"}
                ],
                // 提交的表单
                submitForm: {
                    caiwukpr: ''
                }
            }
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ])
        },
        watch: {
            /**
             * 监听类型的变化
             */
            type (v) {
                this.$nextTick(() => {
                    this.initData(v)
                })
            }
        },
        mounted () {
            this.submitForm.id = this.infoId
            this.initData(this.type)
        },
        methods: {
            initData (v) {
                if (v === 'show') {
                    return
                }
                this.submitForm.caiwukpr = this.userInfo.name
                this.$refs['searchForm'].initBindFormData(this.submitForm)
                if (v === 'update') { // 修改，远程获得修改的数据
                    this.queryEditData()
                }
            },
            /**
             * 获得要修改的数据
             */
            queryEditData () {
                this.$api.queryArr(['api/invoicedealinfo', 'edit'], null, [this.infoId]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 外部调用的数据提交
             */
            submit (callback) {
                if (this.$refs['searchForm'].validateForm()) {
                    // 获得得查询的字段
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                    if (this.type === 'edit') {
                        this._postData().then(callback)
                    } else {
                        this._putData().then(callback)
                    }
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            },
            /**
             * 新增数据
             */
            _postData () {
                return new Promise((resolve, reject) => {
                    this.$api.create('api/invoicedealinfo', this.submitForm).then(() => {
                        resolve()
                    }).catch((error) => {
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                })
            },
            /**
             * 修改数据
             * @return {[type]} [description]
             */
            _putData () {
                return new Promise((resolve, reject) => {
                    this.$api.save('api/invoicedealinfo/' + this.infoId, this.submitForm).then(() => {
                        resolve && resolve()
                    }).catch((error) => {
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                })
            }
        }
    }
</script>